import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "app-link-redirect",
  templateUrl: "./link-redirect.component.html",
  styleUrl: "./link-redirect.component.less",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton],
})
export class LinkRedirectComponent {
  @Input("Title") Title!: string;
  @Input("Link") Link!: string;
  @Input("redirectData") redirectData: string | null = null;

  public get redirectLink(): string {
    console.log(`${this.Link}?data=${this.redirectData}`);
    return this.redirectData !== null ? `${this.Link}?data=${this.redirectData}` : "";
  }

  public redirect(): void {
    window.open(this.redirectLink, "_blank");
  }
}
